import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2TurbineDelete,
  wind2TurbineSave,
  wind2turbineManf,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'

const Wind2TurbineManf = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 200px 300px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Turbine Manufacturer Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Turbine Manufacturer Id :</Label> */}
        <Input
          value={insertData.windTurbineManufacturerId}
          data-cy="turbinemanufactureid"
          onChange={e =>
            setInsertData({
              ...insertData,
              windTurbineManufacturerId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Turbine Manufacturer :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Turbine Manufacturer :</Label> */}
        <Input
          value={insertData.windTurbineManufacturer}
          data-cy="turbinemanufacturer"
          onChange={e =>
            setInsertData({
              ...insertData,
              windTurbineManufacturer: e.target.value,
            })
          }
        />
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }
  return (
    <CommonScreen
      title="Turbine Manufacturer"
      header={Wind2TurbineManufacturerHeaders}
      sortOptions={Wind2TurbineManufacturerHeaders}
      saveTask={wind2TurbineSave}
      retrieveTask={wind2turbineManf}
      deleteTask={wind2TurbineDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      totalWidth={850}
      // heightOffset={100}
    />
  )
}

export default Wind2TurbineManf

const Wind2TurbineManufacturerHeaders = [
  strCol({
    ident: 'windTurbineManufacturerId',
    display: 'Turbine Manufacturer Id',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'windTurbineManufacturer',
    display: 'Turbine Manufacturer',
    isKey: true,
    width: 250,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]
